/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Nav_HomeInputs */

const en_directory_nav_home = /** @type {(inputs: Directory_Nav_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore`)
};

const zh_directory_nav_home = /** @type {(inputs: Directory_Nav_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索`)
};

/**
* | output |
* | --- |
* | "Explore" |
*
* @param {Directory_Nav_HomeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_nav_home = /** @type {((inputs?: Directory_Nav_HomeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Nav_HomeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_nav_home(inputs)
	return zh_directory_nav_home(inputs)
});
export { directory_nav_home as "directory.nav.home" }